<web-widget-breadcrumbs [widget]="widget" [isInSpecificSection]="isSpecific"></web-widget-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <!-- Before Image -->
        <div class="mb-10">
            <sp-file-manager
                [fmSourceType]="fmSourceType.LANDING"
                [file]="beforeImage.value"
                [displayOnly]="[DirectoryItemCategory.Image]"
                (setFileEvent)="setBeforeImage($event)"
                (replaceFileEvent)="replaceBeforeImage($event)"
            >
                <sp-defautl-upload-button
                    *ngIf="!beforeImage.value"
                    [stockImagesDropdown]="true"
                    [disabled]="buttonDisabled"
                    [label]="'widget_before_after_before_image'"
                    (unsplashRequested)="openUnsplashModal('before')"
                ></sp-defautl-upload-button>

                <ng-template
                    #previewTemplate
                    let-file="file"
                    let-replaceFileFn="replaceFileFn"
                    let-buildFilePreviewUrlsFn="buildFilePreviewUrlsFn"
                >
                    <div class="mb-10">
                        <sp-files-select
                            #ref
                            [toggless]="true"
                            (myPhotosClick)="replaceFileFn()"
                            (unsplashClick)="openUnsplashModal('before')"
                        >
                            <sp-control-handle
                                [controlHandleImagePreviewSources]="buildFilePreviewUrlsFn(file)"
                                [controlHandleMainText]="file.name"
                                [controlHandleSubText]="
                                    widgetData?.beforeImage?.imageWidth.toString() +
                                    'x' +
                                    widgetData?.beforeImage?.imageHeight.toString() +
                                    'px'
                                "
                                (removeActionEvent)="removeBeforeFile()"
                                (replaceActionEvent)="ref.dp.toggle()"
                                (imageEditEvent)="showEditBeforeImageModal()"
                                [isDisableEditor]="(userId$ | async) !== beforeImageOwnerUserId"
                            ></sp-control-handle>
                        </sp-files-select>
                    </div>
                </ng-template>
            </sp-file-manager>
        </div>

        <!-- After Image -->
        <div class="mb-20">
            <sp-file-manager
                [fmSourceType]="fmSourceType.LANDING"
                [file]="afterImage.value"
                [displayOnly]="[DirectoryItemCategory.Image]"
                (setFileEvent)="setAfterImage($event)"
                (replaceFileEvent)="replaceAfterImage($event)"
            >
                <sp-defautl-upload-button
                    *ngIf="!afterImage.value"
                    [stockImagesDropdown]="true"
                    [disabled]="buttonDisabled"
                    [label]="'widget_before_after_after_image'"
                    (unsplashRequested)="openUnsplashModal('after')"
                ></sp-defautl-upload-button>

                <ng-template
                    #previewTemplate
                    let-file="file"
                    let-replaceFileFn="replaceFileFn"
                    let-buildFilePreviewUrlsFn="buildFilePreviewUrlsFn"
                >
                    <div class="mb-0">
                        <sp-files-select
                            #ref
                            [toggless]="true"
                            (myPhotosClick)="replaceFileFn()"
                            (unsplashClick)="openUnsplashModal('after')"
                        >
                            <sp-control-handle
                                [controlHandleImagePreviewSources]="buildFilePreviewUrlsFn(file)"
                                [controlHandleMainText]="file.name"
                                [controlHandleSubText]="
                                    widgetData?.afterImage?.imageWidth.toString() +
                                    'x' +
                                    widgetData?.afterImage?.imageHeight.toString() +
                                    'px'
                                "
                                (removeActionEvent)="removeAfterFile()"
                                (replaceActionEvent)="ref.dp.toggle()"
                                (imageEditEvent)="showEditAfterImageModal()"
                                [isDisableEditor]="(userId$ | async) !== afterImageOwnerUserId"
                            ></sp-control-handle>
                        </sp-files-select>
                    </div>
                </ng-template>
            </sp-file-manager>
        </div>
        <div class="form-row">
            <div *ngIf="beforeImage.value || afterImage.value">
                <div class="form-group mb-20">
                    <label class="col-xs-12">
                        {{ "widget_before_after_handle_orientation_color" | translate }}
                    </label>
                    <div class="col-xs-10">
                        <select (change)="setHandleOrientation($event.target['value'])" class="form-control">
                            <option
                                [selected]="handleOrientation.value === EHandleOrientation.vertical"
                                [value]="EHandleOrientation.vertical"
                            >
                                {{ "widget_before_after_vertical_position" | translate }}
                            </option>
                            <option
                                [selected]="handleOrientation.value === EHandleOrientation.horizontal"
                                [value]="EHandleOrientation.horizontal"
                            >
                                {{ "widget_before_after_horizontal_position" | translate }}
                            </option>
                        </select>
                    </div>
                    <div class="col-xs-2">
                        <web-color-picker
                            [color]="handleColor.value"
                            (colorChangeEvent)="setHandleColor($event)"
                            [hideGradient]="true"
                        ></web-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-12 control-label">
                        {{ "widget_before_after_handle_position" | translate }}
                    </label>

                    <div class="col-xs-7">
                        <sp-slider
                            [options]="{
                                minRange: 5,
                                maxLimit: 95,
                            }"
                            [value]="handlePosition.value"
                            (valueChangeEvent)="setHandlePosition($event.value)"
                        >
                        </sp-slider>
                    </div>

                    <div class="col-xs-5">
                        <sp-input-num
                            suffixText="%"
                            [min]="5"
                            [max]="95"
                            [value]="handlePosition.value"
                            (valueChange)="setHandlePosition($event)"
                        ></sp-input-num>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-6 control-label">
                        {{ "control_width" | translate }}
                        <small [tooltip]="imageWidth" class="sp-icon icon-info-bold color-light"> </small>
                        <ng-template #imageWidth>
                            {{ "img_control_max_width" | translate }}
                        </ng-template>
                    </label>

                    <div class="col-xs-6 video-width-control">
                        <img
                            *ngIf="maxWidth.value !== columnWidth"
                            class="refresh-width-btn"
                            src="./assets/img/websites/lpc-return-icon.svg"
                            alt="refresh-icon"
                            [tooltip]="refreshImageWidthTooltip"
                            (click)="refreshImageWidth()"
                        />
                        <ng-template #refreshImageWidthTooltip>
                            {{ "refresh_width_tooltip" | translate }}
                        </ng-template>
                        <sp-input-num
                            suffixText="px"
                            [min]="1"
                            [max]="columnWidth"
                            [value]="maxWidth.value"
                            (valueChange)="setMaxWidth($event)"
                        ></sp-input-num>
                    </div>
                </div>

                <div class="form-group">
                    <label class="control-label col-xs-7">
                        {{ "control_content_alignment" | translate }}
                    </label>
                    <div class="col-xs-5">
                        <sp-radio-group
                            [selected]="horizontalAlign.value"
                            [type]="ERadioGroupType.horizontalPosition"
                            (changeSelectedEvent)="setHorizontalAlign($event)"
                        ></sp-radio-group>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-20">
            <web-custom-id [displayId]="displayId" (valueChangeEvent)="updateWidgetDisplayId($event)"> </web-custom-id>
        </div>
    </div>
</div>
